<template>
  <div class="app-icon-container">
    <div class="portal-navigation-button mr-4">
      <div class="overflow-menu overflow-menu--open-right sidebar-col">
        <button
          :id="id"
          class="button-overflow-menu js-dropdown"
          :data-js-target="menuId"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <svg class="icon-svg" aria-hidden="true">
            <use xlink:href="#apps"></use>
          </svg>
        </button>
        <div
          :id="menuId"
          class="overflow-menu-inner portal-navigation-menu"
          aria-hidden="true"
          style="width: 31rem; height: 42rem"
        >
          <iframe
            :src="`${configStore.strax.url}app-selector`"
            title="description"
            style="border: none; width: 100%; height: 100%"
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";

import { Dropdown } from "dkfds";
import { useConfigStore } from "@/stores/config";
import { newGuid } from "@/utils/uuidUtils";

const configStore = useConfigStore();
const props = defineProps({
  id: {
    type: String,
    default: () => newGuid(),
  },
  containerCssClasses: {
    type: String,
    default: () => "",
  },
});

const menuId = computed(() => `${props.id}-overflow`);

onMounted(() => {
  new Dropdown(document.getElementById(props.id)).init();
});
</script>

<style lang="scss" scoped>
.app-icon-container {
  button {
    margin-top: -0.8rem;
    padding-right: -5rem;
    outline: none;

    svg {
      fill: #066b43;
    }
  }

  .overflow-menu .button-overflow-menu:after,
  .overflow-menu .button-overflow-menu:before {
    left: 30%;
  }

  .portal-navigation-button {
    position: relative;
    background: white;
    padding: 0.5rem;
    border-radius: 1rem;

    width: 3.5rem;
    height: 3.5rem;
  }

  .portal-navigation-button:hover,
  .portal-navigation-button:focus {
    background-color: #dadada !important;
  }
}
</style>
